import LangEnum from '../../../../../../lang/LangEnum';
import { IAffectedOrderProducts } from '../../../../../../services/modules/order/order.types';
import { buildCombinationKey } from '../../../../../orders/products/product/grid/store/gridStore.utils';
import { AvailabilityEnum } from '../../../../../products/ProductTypes';
import {
  CombinationButtonStatusEnum,
  IGridStatus,
} from '../../../../../products/products-details-v2/hooks/useCombination';
import { getProductAvailabilitiesToCleanOrder } from '../../../../../products/products-details-v2/hooks/useProductDetailsActions.utils';

interface ResolvePacksButtonStatusParams {
  totalQuantity: number;
}

export interface CatalogListPacksStatus {
  combinationKey: string;
  status: IGridStatus;
}

interface ResolveGridButtonStatusParams {
  packsStatus: CatalogListPacksStatus | null;
  combinationKey?: string;
  fallback: IGridStatus;
}

interface ResolveKitButtonStatusParams {
  quantity: number;
  isRemoving: boolean;
}

interface BuildRemovedCombinationTargetsParams {
  productColorId: string;
  availability: AvailabilityEnum;
  deliveryWindowId?: string | null;
  orderId: string;
}

export const buildRemovedCombinationTargets = ({
  productColorId,
  availability,
  deliveryWindowId,
  orderId,
}: BuildRemovedCombinationTargetsParams) => {
  const removedOrderProducts: IAffectedOrderProducts[] = getProductAvailabilitiesToCleanOrder(
    availability,
  ).map((removedAvailability) => ({
    productColorId,
    availability: removedAvailability,
    deliveryWindowId: deliveryWindowId ?? undefined,
  }));

  return {
    removedOrderProducts,
    combinationKeys: removedOrderProducts.map((removed) =>
      buildCombinationKey({ ...removed, orderId }),
    ),
  };
};

export const resolvePacksButtonStatus = ({
  totalQuantity,
}: ResolvePacksButtonStatusParams): IGridStatus => ({
  itemQuantity: totalQuantity,
  type:
    totalQuantity > 0 ? CombinationButtonStatusEnum.WITH_PIECES : CombinationButtonStatusEnum.ADDED,
});

export const resolveGridButtonStatus = ({
  packsStatus,
  combinationKey,
  fallback,
}: ResolveGridButtonStatusParams): IGridStatus => {
  if (packsStatus && packsStatus.combinationKey === combinationKey) {
    return packsStatus.status;
  }

  return fallback;
};

export const resolveKitButtonStatus = ({
  quantity,
  isRemoving,
}: ResolveKitButtonStatusParams): IGridStatus => {
  if (isRemoving) {
    return { type: CombinationButtonStatusEnum.LOADING, itemQuantity: 0 };
  }

  if (quantity > 0) {
    return { type: CombinationButtonStatusEnum.ADDED, itemQuantity: quantity };
  }

  return { type: CombinationButtonStatusEnum.ADD, itemQuantity: 0 };
};

interface ResolveBlockedForCustomerTooltipParams {
  isPublic: boolean;
  isBlockedForCustomer: boolean;
}

export const resolveBlockedForCustomerTooltip = ({
  isPublic,
  isBlockedForCustomer,
}: ResolveBlockedForCustomerTooltipParams): LangEnum | undefined => {
  if (isPublic || !isBlockedForCustomer) {
    return undefined;
  }

  return LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_PRODUCT;
};
